<template>
  <div class="setting-advanced-knowledge">
    <div class="setting-knowledge-container">
      <greet-library-manage></greet-library-manage>
    </div>

    <!--    问题dialog-->
    <el-dialog
        :title="dialogTitle"
        width="609px"
        class="editor-dialog"
        @closed="closeModal"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible">
      <el-form :model="problemForm">
        <el-form-item label="问题">
          <el-input v-model="problemForm.title" placeholder="请输入问题" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="回答">
          <div v-if="showEditor" placeholder="请输入回答" ref="editor"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeModal">取 消</el-button>
        <el-button type="primary" @click="submitProblemForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import E from 'wangeditor'
  import greetLibraryManage from "./greetLibrary/greetLibrary-management.vue"

  export default {
    name: 'setting-advanced-knowledge',
	components:{
		greetLibraryManage
	},
    data() {
      return {
        dialogFormVisible: false,
        showEditor: false,
        dialogTitle: '新建问题',
        editor: null,
		accept: 'image/gif, image/jpeg, image/png, image/jpg',
        problemForm: {
          id:'',
          title: '',
          answer: '',
		  answerRich:''
        },
        answerOnlyPic: false,
      }
    },
    created() {

    },
    mounted() {
      eventBus.$on('editProblem', (data) => {
        this.editProblem(data)
      })
	  eventBus.$on('addProblem', (data) => {
	    this.addNewPeoblem()
	  })
    },
    computed: {
		
    },
    methods: {
      closeModal() {
        this.showEditor = false
        this.dialogFormVisible = false
        this.problemForm = {
          id:'',
          name: '',
          standard: '',
          external: ''
        }
      },
      initEditor(data) {
        let editor = new E(this.$refs.editor)
        this.editor = editor
        editor.customConfig.menus = [
          'head',
          'bold',
          'italic',
          'underline',
          'list',
          'justify',
          'image',
          'link',
        ]
        let _that = this
        editor.customConfig.linkImgCallback = function (url) {
          _that.answerOnlyPic = true
        }
        editor.customConfig.customUploadImg = function (files, insert) {
          let img = files[0]
          let type = img.type
          let size = img.size
          if (_that.accept.indexOf(type) == -1) {
            _that.$message({
              showClose: true,
              message: '图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg',
              type: 'error',
              duration: 3 * 1000
            })
            return false
          }
          if (size > 5242880) {
            _that.$message({
              showClose: true,
              message: '请选择5M以内的图片！',
              type: 'error',
              duration: 3 * 1000
            })
            return false
          }
          let formdata = new FormData()
          formdata.set('file', img)
          _that.$http.uploadImageAPI(formdata).then(res => {
            if (res.status == 1) {
              _that.answerOnlyPic = true
              insert(res.data)
            }
          })
          // files 是 input 中选中的文件列表
          // insert 是获取图片 url 后，插入到编辑器的方法

        }
        editor.create()

        editor.txt.html(data)
      },
      addNewPeoblem() {
        this.dialogTitle = '新建问题'
        this.showEditor = true
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.initEditor()
        })
      },
      editProblem(data) {
        this.dialogTitle = '编辑问题'
        this.showEditor = true
        this.dialogFormVisible = true
        this.$nextTick(() => {
		  let answer = data.richAnswer || data.answer
          this.initEditor(answer)
          this.problemForm = {
            id:data.id,
            title:data.title,
          }
        })
      },
      submitProblemForm() {
        let reg = /&nbsp;/g;
        let content = this.editor.txt.text()
		this.problemForm.answer= content
        this.problemForm.answerRich = this.editor.txt.html()
        if(this.$utils.u_isEmpty(this.problemForm.title)) {
          this.$message({
            message: '问题不能为空',
            type: 'error',
          })
          return  false
        }
        if(!this.answerOnlyPic && content.replace(reg,'').trim().length == 0){
          this.$message({
            message: '回答不能为空',
            type: 'error',
          })
          return false
        }
        this.$http.addOrEditGreetingAPI(this.problemForm).then(res => {
          if(res.status == 1){
            eventBus.$emit('reloadProblemTable')
            this.closeModal()
            this.$message({
              message: res.msg,
              type: 'success',
            })
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
    }
  }
</script>

<style lang="scss">

  .setting-advanced-knowledge {
	
    .setting-advanced-tab-container {
      display: flex;
      padding: 24px 24px 17px;
      position: relative;

      li {
        margin-right: 40px;
        color: #333333;
        font-size: 12px;
        letter-spacing: 1.4px;
        cursor: pointer;
        padding-bottom: 7px;
      }

      .recharge-btn {
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -20px;
        margin-right: 0;

        span + span {
          margin-left: 20px;
        }
      }
    }

    .setting-knowledge-container {
      margin-top: 15px;
    }

    .dialog-footer {
      text-align: center;
    }

    .el-form-item__label {
      float: none;
      font-weight: bold;
      color: #333;
    }

    .el-select {
      width: 100%;
    }

    .editor-dialog {
      li {
        list-style: inherit;
      }

      img {
        max-width: 300px !important;
      }

      a {
        color: $mainColor;
        text-decoration: underline;
      }
      .w-e-text-container{
        height: 230px!important;
      }
    }

  }
</style>
